module.exports = __webpack_public_path__ + "img/emmanuel.25da2570.png";